<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vs-tabs>
    <vs-tab label="Day">
      <AttendToday/>
    </vs-tab>
    <!-- <vs-tab label="전체">
      <AttendAll/>
    </vs-tab> -->
    <!-- <vs-tab label="결과물">
      <InsightReport/>
    </vs-tab>
    <vs-tab label="시험">
      <InsightTest/>
    </vs-tab> -->
  </vs-tabs>
</template>

<script>
// Cell Renderer
import AttendToday from "./attend/AttendToday.vue"
import AttendAll from "./attend/AttendAll.vue"

export default {
  components: {
    AttendToday,
    AttendAll,
  },
  watch:{
  },
  methods: {
  },
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
